import {FieldValidationRules} from '../types';

export const restrictedSicCodesForHI = [
  '1799',
  '2892',
  '5812',
  '5813',
  '5999',
  '7299',
  '7389',
  '7999',
  '8611',
  '8621',
  '8631',
  '8641',
  '8651',
  '8661',
  '8699',
  '8999',
  '9121',
  '9131',
  '9199',
  '9999',
];

export const HIValidationRules: Record<string, FieldValidationRules> = {
  'HIFundingStructure.payrollFrequency': {
    required: true,
    errorMessages: {
      required: "'Payroll Frequency' is mandatory",
    },
  },
  'EligibleLivesAndParticipation.numberOfEligibleLives': {
    required: true,
    min: 3,
    max: 499,
    errorMessages: {
      required: "'Number of lives' is required",
      minMax: "'Number of lives' should be between 3 and 499",
    },
  },
  'HIHosAdmissionBenefit.benefitAmount': {
    required: true,
    min: 0,
    max: 1100,
    errorMessages: {
      required: 'The value is required',
      minMax: 'The value must be between 100 and 1100 with step 50',
    },
  },
  'HIHosConfinementBenefit.benefitAmount': {
    required: true,
    min: 0,
    max: 1100,
    errorMessages: {
      required: 'The value is required',
      minMax: 'The value must be between 100 and 1100 with step 50',
    },
  },
  'HIICUConfinementBenefit.benefitAmount': {
    required: true,
    min: 0,
    max: 1100,
    errorMessages: {
      required: 'The value is required',
      minMax: 'The value must be between 100 and 1100 with step 50',
    },
  },
};
